import { render, staticRenderFns } from "./CreditCardIugu.vue?vue&type=template&id=54776bae&"
import script from "./CreditCardIugu.vue?vue&type=script&lang=js&"
export * from "./CreditCardIugu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports